// Получение CSRF токена из cookie
function getCsrfTokenFromCookie(): string | null {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') {
      return value;
    }
  }
  return null;
}

// Получение CSRF токена (сначала из cookie, если нет - запрос к API)
async function getCsrfToken(): Promise<string> {
  let token = getCsrfTokenFromCookie();

  if (!token) {
    // Если нет cookie, делаем GET запрос чтобы Django поставил cookie
    await fetch('/api/login', {
      method: 'GET',
      credentials: 'include',
    });
    token = getCsrfTokenFromCookie();
  }

  return token || '';
}

// Базовая функция для HTTP запросов с CSRF защитой
export async function csrfFetch(url: string, options?: RequestInit): Promise<Response> {
  const csrfToken = await getCsrfToken();

  const defaultHeaders = {
    'Content-Type': 'application/json',
    'X-CSRFToken': csrfToken,
  };

  const mergedOptions: RequestInit = {
    ...options,
    credentials: 'include', // Для cookies
    headers: {
      ...defaultHeaders,
      ...options?.headers,
    },
  };

  return fetch(url, mergedOptions);
}

/**
 * Безопасно парсит тело ошибки из response
 * Возвращает сообщение об ошибке или fallback
 *
 * Используется для обработки { code, message } от FastAPI/Pydantic
 * и предотвращения UnhandledRejection в Sentry
 */
export async function parseErrorResponse(
  response: Response,
  fallbackMessage: string
): Promise<string> {
  try {
    const errorData = await response.json();
    if (errorData && errorData.message) {
      return errorData.message;
    }
    if (errorData && errorData.detail) {
      // FastAPI также может возвращать detail
      return typeof errorData.detail === 'string'
        ? errorData.detail
        : JSON.stringify(errorData.detail);
    }
  } catch {
    // Если не JSON, используем statusText
    return response.statusText || fallbackMessage;
  }
  return fallbackMessage;
}
